import type { ResourceArticle } from '~/types/ResourceArticle'

export const problemsWithEatingArticle: ResourceArticle = {
  uid: 'problems-with-eating',
  thumbnailImageUrl: 'https://cdn.hubofhope.co.uk/public/img/thumbs/RESOURCES_EATING_800x800.jpg',
  thumbnailImageAlt: 'Problems with eating',
  title: 'Problems with eating',
  supportNeedCategoryLabel: 'Eating disorders',
  supportNeedCategoryUid: 'eFrtfCIC5UNpUCAaWrKh',
  isFeatured: true,
  excerpt:
    'Many of us have difficulties around food and eating. If severe, these are sometimes called eating disorders.',
  content: `
  <div class="prose mt-4">
    <p class="font-bold">
      Many of us have difficulties around food and eating. If severe, these are sometimes called eating disorders.
    </p>
  
    <p class="mt-4">
      Sometimes we can become very preoccupied with trying to lose weight. We might severely restrict our food intake or perhaps exercise compulsively. If someone’s weight becomes very low, perhaps dangerously low, the term anorexia is often used.
    </p>
  
    <p class="mt-4">
      Sometimes we can become stuck in a cycle of restricting our food intake but then eating a lot at once (bingeing) and perhaps taking laxatives or making ourselves vomit to get rid of the food. This cycle is sometimes called bulimia.
    </p>
  
    <blockquote class="italic border-l-4 border-gray-300 pl-4 mt-4">
      “Both men and women can experience problems with eating, but as a result of social pressures they are particularly common in teenage girls and young women.”
    </blockquote>
  
    <figure class="my-8">
      <img src="https://cdn.hubofhope.co.uk/public/img/thumbs/jorge-bermudez-D-_jv5F4VtU-unsplash_800x800.jpg"
           alt="Problems with eating article image" 
           class="max-w-md w-full h-auto rounded shadow-md mx-auto">
    </figure>
  
    <h2 class="font-semibold text-lg font-brown text-primary mt-8">Seeking support</h2>
    <p class="mb-8">
      In terms of support, different things help different people. Therapy or counselling can help us understand what might have led to our difficulties around food and eating, including past traumatic experiences 
      (<a href="/resource/trauma-post-traumatic-stress" class="text-blue-500 underline hover:text-blue-700">see Trauma & post-traumatic stress</a>), and what might be keeping them going. This can help us to unpick the cycles and find the best way forward. Connecting with others with similar experiences either informally or in organised peer support groups can also be helpful. GPs should also be able to provide referrals to specialist services.
    </p>
  </div>`
}
